import { render, staticRenderFns } from "./UserNotificationSettingByAdmin.vue?vue&type=template&id=381bb311"
import script from "./UserNotificationSettingByAdmin.vue?vue&type=script&lang=js"
export * from "./UserNotificationSettingByAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports